import * as React from 'react'
import { StoreProvider } from './src/context/StoreContext'
import './src/styles/variables.css'

export const wrapRootElement = ({ element }) => (
  <StoreProvider>{element}</StoreProvider>
)
